import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box, Button, Grid, Typography
} from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import {
  apiGetPlayer,
  PlaylistState
} from '../../store/playlistSlice';
import { OrganisationContext } from '../../App';
import { useParams } from 'react-router-dom';
import { RootState } from '../../index';
import { CreativeTagState, DealState, PlayerState } from '../types/playlist';
import ToolBarPlaylist from '../ToolBarPlaylist';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/env';
import removeButton from '../../icons/remove.png';
import { ReactComponent as PencilIcon } from '../../icons/pencil.svg';
import { AddCreativeDealDialog } from '../modal/AddCreativeDealDialog';
import Table from '@mui/material/Table';
import { TableCellBody, TableCellHead, TableRow } from '../common/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import { Heading } from '../common/Heading';

export default function PlaylistCreativeTagDeals() {
  const { playlist, creativeId, tagId } = useParams();
  const dispatchRedux = useDispatch();
  const { selectedOrganisation } = useContext(OrganisationContext);
  const [creative, setCreative] = useState<PlayerState>();

  // Deals list
  const [tag, setTag] = useState<CreativeTagState>();
  const [deals, setDeals] = useState<DealState[]>([]);

  // Currently edited/created deal (compatible with dialog expectations)
  const [deal, setDeal] = useState<DealState | undefined>();

  const getDeals = async () => {
    const { data } = await axios.get(`${getApiBaseUrl()}/playlist-tag/${selectedOrganisation}/deal/${tagId}`);
    setDeals(data);
  };

  const {
    currentPlaylist,
    players,
  } = useSelector<RootState, PlaylistState>((state) => state.playlist);

  useEffect(() => {
    if (!selectedOrganisation) return;
    dispatchRedux(apiGetPlayer({
      publisher: selectedOrganisation,
      playlistId: playlist
    }));
    getDeals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganisation, playlist]);

  useEffect(() => {
    if (tagId) {
       axios.get(`${getApiBaseUrl()}/playlist-tag/${selectedOrganisation}/${creativeId}`)
         .then(({ data }) => {
           const tag = data.find(({ id }) => id === Number(tagId));
           if (tag) setTag(tag)
         });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagId]);

  useEffect(() => {
    const creative = players.find(({ id }) => id === Number(creativeId));

    if (creative) setCreative(creative);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [creativeId, players]);

  if (!currentPlaylist) {
    return <p>Loading..</p>;
  }

  const onEditDeal = (d: DealState) => {
    setDeal(d);
  };
  const onRemoveDeal = async (d: DealState) => {
    if (window.confirm(`Are you sure you want to remove '${d.ssp}'?`)) {
      await axios.delete(`${getApiBaseUrl()}/playlist-tag/${selectedOrganisation}/deal/${creativeId}/${d.id}`);
      await getDeals();
    }
  };

  return (
    <Box>
      <ToolBarPlaylist playlist={currentPlaylist} creative={creative} tag={tag} />
      <Grid item xs={12}>
        <Grid container justifyContent={'space-between'} alignItems="center">
          <Grid item>
            <Heading>Deals</Heading>
          </Grid>
          <Grid item>
            <Button color="primary" variant="contained"
                    onClick={() => setDeal({
                      playlist_creative_tag_id: Number(tagId as string),
                      ssp: '',
                      geos: [],
                      deal_id: '',
                      segments: []
                    })}
                    startIcon={<AddCircleIcon/>}
                    type={'button'}>Add Deal</Button>
          </Grid>
        </Grid>
      </Grid>

      {deals.length > 0 && (
        <Table size="small" sx={{ mt: 2 }}>
          <TableHead>
            <TableRow>
              <TableCellHead>SSP</TableCellHead>
              <TableCellHead>DEAL ID</TableCellHead>
              <TableCellHead>GEO</TableCellHead>
              <TableCellHead>SEGMENTS</TableCellHead>
              <TableCellHead>ACTION</TableCellHead>
            </TableRow>
          </TableHead>
          <TableBody>
            {deals.map((d) => (
              <TableRow key={d.id}>
                <TableCellBody>{d.ssp}</TableCellBody>
                <TableCellBody>{d.deal_id}</TableCellBody>
                <TableCellBody>{d.geos.join(', ')}</TableCellBody>
                <TableCellBody>{(d.segments || []).join(', ')}</TableCellBody>
                <TableCellBody align="center">
                  <Grid container justifyContent={'flex-start'} spacing={2}>
                    <Grid item>
                      <PencilIcon style={{ cursor: 'pointer' }} onClick={() => onEditDeal(d)}/>
                    </Grid>
                    <Grid item>
                      <span onClick={() => onRemoveDeal(d)} style={{ cursor: 'pointer' }}>
                        <img width={20} src={removeButton} alt="Remove deal"/>
                      </span>
                    </Grid>
                  </Grid>
                </TableCellBody>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}

      {deals.length === 0 && (
        <Grid container spacing={2}>
          <Grid item xs={12}><Typography>No deals found</Typography></Grid>
        </Grid>
      )}

      {deal && <AddCreativeDealDialog creative={creative as PlayerState} open={Boolean(deal)}
                                      handleClose={() => {
                                        setDeal(undefined);
                                        getDeals();
                                      }} deal={deal}/>}
    </Box>
  );
}
